const apiUrl = "https://gapi.astrogeomancy.ir";
// const apiUrl = "https://localhost:7254";

export default apiUrl;
